(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-test"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var items = root.querySelectorAll('.pj-day__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.pj-day__btn');
        var panel = item.querySelector('.pj-day__panel');
        if (item.classList.contains('is-open')) { panel.style.maxHeight = panel.scrollHeight + 'px'; }
        btn.addEventListener('click', function () {
          var open = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        });
      });
      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (item.classList.contains('is-open')) { item.querySelector('.pj-day__panel').style.maxHeight = item.querySelector('.pj-day__panel').scrollHeight + 'px'; }
        });
      });
    }
    function boot() { document.querySelectorAll('.pj-day').forEach(init); }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('.pj-day'); if (s) init(s); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-side-menu"] && !Shopify.designMode) return;
  try {
    
  function prSideMenuInit(root) {
    if (!root || root.dataset.smenuReady) return;
    root.dataset.smenuReady = '1';

    var selector = root.dataset.trigger || '.logo-area .mobile-nav-toggle';
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('smenu-open');
      var first = root.querySelector('.smenu__close');
      if (first) first.focus();
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('smenu-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* Capture phase: fire before the theme's own menu handler, and stop it dead.
       Without stopImmediatePropagation the theme's mobile drawer opens behind
       this one. */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest(selector) : null;
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (root.classList.contains('is-open')) { close(); } else { open(); }
    }, true);

    root.querySelectorAll('[data-smenu-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    /* close when a link is followed */
    root.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', function () { close(); });
    });
  }

  function prSideMenuBoot(scope) {
    (scope || document).querySelectorAll('[data-smenu]').forEach(prSideMenuInit);
  }
  document.addEventListener('DOMContentLoaded', function () { prSideMenuBoot(); });
  document.addEventListener('shopify:section:load', function (e) { prSideMenuBoot(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-hero-new"] && !Shopify.designMode) return;
  try {
    
  class PressHeroSlider {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('.hs__slide'));
      this.dots = Array.from(root.querySelectorAll('[data-hs-dot]'));
      this.current = 0;
      this.count = this.slides.length;
      this.transition = root.dataset.transition || 'fade';
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = root.dataset.autoplay === 'true' && !this.reduced && this.count > 1;
      this.speed = (parseFloat(root.dataset.autoplaySpeed) || 6) * 1000;
      this.timer = null;

      if (this.count <= 1) { this.playVideo(0); return; }

      this.bind();
      this.goTo(0, true);
      this.observe();
    }

    bind() {
      const prev = this.root.querySelector('[data-hs-prev]');
      const next = this.root.querySelector('[data-hs-next]');
      if (prev) prev.addEventListener('click', () => { this.goTo(this.current - 1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.goTo(this.current + 1); this.restart(); });
      this.dots.forEach((d) => d.addEventListener('click', () => {
        this.goTo(parseInt(d.dataset.hsDot, 10)); this.restart();
      }));

      this.root.addEventListener('mouseenter', () => this.stop());
      this.root.addEventListener('mouseleave', () => this.start());
      this.root.addEventListener('focusin', () => this.stop());
      this.root.addEventListener('focusout', () => this.start());

      this.root.setAttribute('tabindex', '0');
      this.root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.goTo(this.current - 1); this.restart(); }
        if (e.key === 'ArrowRight') { this.goTo(this.current + 1); this.restart(); }
      });

      let startX = 0;
      this.root.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.root.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) { this.goTo(this.current + (dx < 0 ? 1 : -1)); this.restart(); }
      }, { passive: true });
    }

    goTo(index, instant) {
      const i = (index + this.count) % this.count;
      const prevI = this.current;
      this.current = i;

      this.slides.forEach((slide, n) => {
        slide.classList.toggle('is-active', n === i);
        slide.classList.toggle('is-prev', this.transition === 'slide' && n === prevI && n !== i && !instant);
      });
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));

      this.slides.forEach((slide, n) => {
        const v = slide.querySelector('video');
        if (!v) return;
        if (n === i) { v.play().catch(() => {}); } else { v.pause(); }
      });
    }

    playVideo(i) {
      const v = this.slides[i] && this.slides[i].querySelector('video');
      if (v) v.play().catch(() => {});
    }

    start() { if (this.autoplay && !this.timer) this.timer = setInterval(() => this.goTo(this.current + 1), this.speed); }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    restart() { this.stop(); this.start(); }

    observe() {
      if (!('IntersectionObserver' in window)) { this.start(); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { this.start(); this.playVideo(this.current); }
          else { this.stop(); }
        });
      }, { threshold: 0.2 });
      io.observe(this.root);
    }
  }

  function initPressHeroes(scope) {
    (scope || document).querySelectorAll('[data-press-hero]').forEach((el) => {
      if (el.dataset.phInit) return;
      el.dataset.phInit = 'true';
      el.pressHero = new PressHeroSlider(el);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initPressHeroes());

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => initPressHeroes(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest('[data-press-hero]');
    if (root && root.pressHero) { root.pressHero.stop(); root.pressHero.goTo(parseInt(e.target.dataset.index, 10)); }
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const root = e.target.closest('[data-press-hero]');
    if (root && root.pressHero) root.pressHero.start();
  });

  } catch(e) { console.error(e); }
})();
})();
